import { render, staticRenderFns } from "./ProposalModal.vue?vue&type=template&id=3b52af82&scoped=true&"
import script from "./ProposalModal.vue?vue&type=script&lang=ts&"
export * from "./ProposalModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProposalModal.vue?vue&type=style&index=0&id=3b52af82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b52af82",
  null
  
)

component.options.__file = "ProposalModal.vue"
export default component.exports